module.exports = __webpack_public_path__ + "static/media/au.e875a51e.svg";